import { render, staticRenderFns } from "./groupCombo.vue?vue&type=template&id=c9c80f7e&scoped=true"
import script from "./groupCombo.vue?vue&type=script&lang=ts"
export * from "./groupCombo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c80f7e",
  null
  
)

export default component.exports